export interface VehicleEnvironmentDto {
  leftDoorOpen?: boolean;
  rightDoorOpen?: boolean;
  chargePortOpen?: boolean;
  pilotPresent?: boolean;
  charging?: boolean;
  handBrakeApplied?: boolean;
  ignition?: boolean;
  carLocked?: boolean;
  valetMode?: boolean;
  bonnet?: boolean;
  trunk?: boolean;
  pemTemperature?: number;
  motorTemperature?: number;
  batteryTemperature?: number;
  tripMeter?: number;
  odometer?: number;
  speed?: number;
  parkingTimer?: number;
  ambientTemperature?: number;
  carAwake?: boolean;
  coolingPump?: boolean;
  loggedIntoMotorController?: boolean;
  motorControllerConfigurationMode?: boolean;
  staleTemperaturesIndicator?: number;
  staleAmbientTemperatureIndicator?: number;
  voltage12V?: number;
  alarmSounds?: boolean;
  referenceVoltage12V?: number;
  rearLeftDoorOpen?: boolean;
  rearRightDoorOpen?: boolean;
  frunkOpen?: boolean;
  batteryCharging12V?: boolean;
  auxiliary12VSystemsOnline?: boolean;
  hvacRunning?: boolean;
  chargerTemperature?: number;
  dcConverterOutput12V?: number;
  cabinTemperature?: number;
}
